import { cn } from '@/app/utils/cn';

export function LoadingPosts({ className = '', children }) {
    return (
        <div className={cn('w-full text-center text-gray-500', className)}>
            {children ?? 'Loading posts...'}
        </div>
    );
}

export default LoadingPosts;
